import React from "react";
import { Grid, GTIWebTabs, GTIWebTabPanel } from "@gti-controls-v2/web-core";
import Sessions from "./sessions";
import Support from "./support";

const HistoryMo = ({ TicketID, data, lookup }) => {
    return (
        <Grid>
            <GTIWebTabs >
                {/* ****************  TAB SOPORTE **************** */}
                <GTIWebTabPanel label="Soporte" >
                    <Support TicketID={TicketID} data={data?.Soporte}/>
                </GTIWebTabPanel>
                
                {/* ****************  TAB SESIONES **************** */}
                <GTIWebTabPanel label="Sesiones" >
                    <Sessions TicketID={TicketID} data={data?.Sessions} lookup={lookup}/>
                </GTIWebTabPanel>
            </GTIWebTabs>
        </Grid>
    )
};

export default HistoryMo;